// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const GroupIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="GroupIcon" ref={forwardedRef} {...props}>
      <path d="M11 6a3.5 3.5 0 1 0-7 0 3.5 3.5 0 0 0 7 0M7.5 4a2 2 0 1 1 0 4 2 2 0 0 1 0-4" />
      <path d="M17 7a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0m-2.5-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />
      <path d="M12 11a1 1 0 0 1 1 1v4.5H2V12a1 1 0 0 1 1-1zm-8.5 1.5v4h8.004V15H11.5v-2.5z" />
      <path d="M16.496 12H14.5a2.5 2.5 0 0 0-.5-1.5h2.996a1 1 0 0 1 1 1v4h-1.498V14h-.002z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const GroupIcon = /* @__PURE__ */ Object.assign(GroupIconComponent, {
  displayName: 'GroupIcon',
});
